<template>
  <div>
    <div class="white-wrapper">
      <form class="row">
        <!-- CINEMAS SELECTION -->
        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="userDetails.first_name"
                name="firstname"
                id="firstname"
                v-validate="'required|alpha_spaces'"
              />
              <label>{{ $t('First Name') }}</label>
            </div>
            <Tooltip :title="$t('user_NameTooltip')" />
          </div>
          <p
            v-if="submitted && errors.has('firstname')"
            class="error_message"
          >{{ errors.first('firstname') }}</p>
        </div>

        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input placeholder="." type="text" v-model="userDetails.middle_name" />
              <label>{{ $t('middlename') }}</label>
            </div>
            <Tooltip :title="$t('user_MiddleName')" />
          </div>
          <p
            v-if="submitted && errors.has('middlename')"
            class="error_message"
          >{{ errors.first('middlename') }}</p>
        </div>

        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="userDetails.last_name"
                type="text"
                name="lastnamee"
                id="lastnamee"
                v-validate="'required|alpha'"
              />
              <label>{{ $t('lastname') }}</label>
            </div>
            <Tooltip :title="$t('user_LastName')" />
          </div>
          <p
            v-if="submitted && errors.has('lastnamee')"
            class="error_message"
          >{{ errors.first('lastnamee') }}</p>
        </div>

        <!-- <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Gender" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(gender, genderIndex) in Gender"
                :key="genderIndex"
                v-on:click="onSelectHandler('gender',gender)"
                name="selectgender"
                id="selectgender"
              >{{ gender.gender }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Gender')" />
        </div>-->

        <!-- <div class="col-md-6 mb-4">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Country" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(country, countryIndex) in Countries"
                :key="countryIndex"
                v-on:click="onSelectHandler('country',country)"
                name="selectcountry"
                id="selectcountry"
              >{{ country.country_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Country')" />
          </div>
          <p
            v-if="submitted && selected.Country == 'Select Country'"
            class="error_message"
          >{{ this.messagecountry }}</p>
        </div>-->

        <!-- <div class="col-md-6 mb-4">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.State" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(state,stateIndex) in States"
                :key="stateIndex"
                @click="onSelectHandler('state',state)"
                name="selectstate"
                id="selectstate"
              >{{ state.state_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_State')" />
          </div>
          <p
            v-if="submitted && selected.State == 'Select State'"
            class="error_message"
          >{{ this.messagestate }}</p>
        </div>-->

        <!-- <div class="col-md-6 mb-4">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.City" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(city,cityIndex) in Cities"
                :key="cityIndex"
                @click="onSelectHandler('city',city)"
                name="selectcity"
                id="selectcity"
              >{{ city.city_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Cities')" />
          </div>
          <p
            v-if="submitted && selected.City == 'Select City'"
            class="error_message"
          >{{ this.messagecity }}</p>
        </div>-->

        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="userDetails.email_id"
                type="email"
                name="a_email_id"
                id="a_email_id"
                v-validate="'required|email'"
              />
              <label>{{ $t('emailaddress') }}</label>
            </div>
            <Tooltip :title="$t('user_EmailId')" />
          </div>
          <p
            v-if="submitted && errors.has('a_email_id')"
            class="error_message"
          >{{ errors.first('a_email_id') }}</p>
        </div>

        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <!-- <b-dropdown
              :text="SelectedCountryCode"
              variant="dropdown-curve-lg bg-theme-light"
              class="w-50"
            >
              <b-dropdown-item
                href="#"
                v-for="(countrycode, countryIndex) in Countries"
                :key="countryIndex"
                v-on:click="onSelectHandler('countrycode',countrycode)"
              >{{ countrycode.country_mob_code }}</b-dropdown-item>
            </b-dropdown>-->
            <multiselect
              :options="Countries"
              :searchable="true"
              :placeholder="SelectedCountryCode && SelectedCountryCode.length > 0 ? SelectedCountryCode : 'Country Code'"
              label="country_mob_code"
              track-by="country_id"
              @select="onSelectHandler('countrycode',$event)"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
            <div class="input-material">
              <input
                placeholder="."
                v-model="userDetails.mobile_no"
                type="text"
                name="mobileno"
                id="monileno"
                v-validate="'required|numeric|min:6|max:14'"
              />
              <label>{{ $t('mobiles') }}</label>
            </div>
            <Tooltip :title="$t('user_mobile')" />
          </div>
          <p
            v-if="submitted && errors.has('mobileno')"
            class="error_message"
          >{{ errors.first('mobileno') }}</p>
        </div>

        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="userDetails.username"
                type="text"
                name="username"
                id="username"
                v-validate="{required: 'required', regex:/^[a-zA-Z0-9-_@]+$/}"
              />
              <!-- v-validate="'required|alpha_num'" -->
              <label>{{ $t('username') }}</label>
            </div>
            <Tooltip :title="$t('user_Username')" />
          </div>
          <p
            v-if="submitted && errors.has('username')"
            class="error_message"
          >{{ errors.first('username') }}</p>
        </div>

        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="userDetails.password"
                type="password"
                name="password"
                id="password"
                v-validate="{required: 'required', regex:/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{4,15}$/}"
              />
              <label>{{ $t('password') }}</label>
            </div>
            <Tooltip :title="$t('user_Password')" />
          </div>
          <p
            v-if="submitted && errors.has('password')"
            class="error_message"
          >{{ errors.first('password') }}</p>
        </div>

        <!-- <div class="col-md-6 mb-4">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Role" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(role,roleIndex) in Roles"
                :key="roleIndex"
                @click="onSelectHandler('role',role)"
                name="selectrole"
                id="selectrole"
              >{{ role.role_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Roles')" />
          </div>
          <p
            v-if="submitted && selected.Role == 'Select Role'"
            class="error_message"
          >{{ this.messagerole }}</p>
        </div>-->

        <!-- <div v-if="!flag.isDistributor" class="col-md-6 mb-4">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Designation" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(designation,designationIndex) in Designations"
                :key="designationIndex"
                @click="onSelectHandler('designation',designation)"
                name="selectdesignation"
                id="selectdesignation"
              >{{ designation.designation }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Designation')" />
          </div>
          <p
            v-if="submitted && selected.Designation == 'Select Designation'"
            class="error_message"
          >{{ this.messagedesignation }}</p>
        </div>-->

        <!-- <div v-if="!flag.isDistributor" class="col-md-6 mb-4">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Cinemas" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(cinema,cinemaIndex) in Cinemas"
                :key="cinemaIndex"
                @click="onSelectHandler('cinema',cinema)"
                name="selectcinema"
                id="selectcinema"
              >{{ cinema.cine_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Cinema')" />
          </div>
          <p
            v-if="submitted && selected.Cinemas == 'Select Cinema'"
            class="error_message"
          >{{ this.messagecinema }}</p>
        </div>-->

        <!-- Employee -->
        <!-- Employee -->

        <!-- Department -->

        <!-- <div v-if="!flag.isDistributor" class="col-md-6 mb-4">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Departments" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(department,departmentIndex) in Departments"
                :key="departmentIndex"
                @click="onSelectHandler('department',department)"
                name="selectdepartment"
                id="selectdepartment"
              >{{ department.dept_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Department')" />
          </div>
          <p
            v-if="submitted && selected.Departments == 'Select Department'"
            class="error_message"
          >{{ this.messagedepartment }}</p>
        </div>-->

        <!-- Distributor -->

        <!-- Department -->

        <div class="col-md-12 text-center mt-4">
          <button
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue"
          >{{ $t('save') }} & {{ $t('proceed') }}</button>
          <!-- <button @click.prevent.stop="onResetForm" class="btn-black">{{ $t('reset') }}</button> -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import UserService from "@/services/UserService";

const selected = {
  Country: "",
  Gender: "",
  Departments: "",
  Cinemas: "",
  Role: "",
  State: "",
  City: "",
  Designation: "",
  Distributor: "Select Distributor",
};

export default {
  data() {
    return {
      SelectedCountryCode: "Country Code",
      messagegender: "Please Select Gender.",
      messagecountry: "Please Select Country.",
      messagestate: "Please Select State.",
      messagecity: "Please Select City.",
      messagerole: "Please Select Role.",
      messagedesignation: "Please Select Designation.",
      messagecinema: "Please Select Cinema.",
      messagedepartment: "Please Select Department.",

      submitted: false,
      customRegex: "//",
      userDetails: {
        username: "",
        user_profile_image_url: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        email_id: "",
        mobile_no: "",
        cinema_id: "0",
        role_id: 2,
        password: "",
        zipcode: "0",
        //userprofileData
        up_employee_code: "",
        up_dob: "",
        up_doj: "",
        up_address1: "",
        up_alt_contact_no: "",
        // dropdown ids
        designation_id: null,
        gender_id: null,
        city_id: null,
        state_id: null,
        country_id: null,
        department_id: null,
        d_id: null,
      },
      selected: selected,

      flag: {
        isDistributor: false,
      },

      Distributors: [],

      //
      Genres: [],
      GenresMethod: {
        GET: "/admin/",
        tableName: "ms_genre",
        urlKey: "genres",
      },
      Gender: [],
      GenderMethod: {
        GET: "/admin/",
        tableName: "ms_gender",
        urlKey: "gender",
      },
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },

      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states",
      },

      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities",
      },

      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles",
      },

      Designations: [],
      DesignationsMethods: {
        GET: "/admin/",
        tableName: "ms_designations",
        urlKey: "designations",
      },
      Cinemas: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
      Departments: [],
      DepartmentsMethods: {
        GET: "/admin/",
        tableName: "ms_departments",
        urlKey: "departments",
      },
    };
  },
  beforeMount() {
    // this.getGenderList();
    // this.getGenreList();
    this.getCountriesList();
    // this.getRolesList();
    // this.getDesignationList();
    // this.getCinemasList();
    // this.getDepartmentList();
    // this.getDistributorsList();
  },
  mounted() {
    const { userid } = this.$route;
  },
  methods: {
    onResetForm: function () {
      this.userDetails = {
        username: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        email_id: "",
        mobile_no: "",
        cinema_id: "",
        role_id: "",
        password: "",
        zipcode: "",
        //userprofileData
        up_employee_code: "",
        up_dob: "",
        up_doj: "",
        up_address1: "",
        up_alt_contact_no: "",
        user_profile_image_url: "",
        // dropdown ids
        designation_id: null,
        gender_id: null,
        city_id: null,
        state_id: null,
        country_id: null,
        department_id: null,
        d_id: null,
      };
      this.selected = {
        ...selected,
      };
    },
    clearSelectedDate: function () {
      this.userDetails.up_dob = "";
    },
    cleardoj: function () {
      this.userDetails.up_dob = "";
    },
    onSelectHandler: function (type, value) {
      if (type == "gender") {
        this.selected.Gender = value.gender;
        this.userDetails.gender_id = value.gender_id;
      } else if (type == "country") {
        this.selected.Country = value.country_name;
        this.userDetails.country_id = value.country_id;
        this.getStatesList(value.country_id);
      } else if (type == "state") {
        this.selected.State = value.state_name;
        this.userDetails.state_id = value.state_id;
        this.getCitiesList(value.state_id);
      } else if (type == "city") {
        this.selected.City = value.city_name;
        this.userDetails.city_id = value.city_id;
      } else if (type == "countrycode") {
        this.SelectedCountryCode = value.country_mob_code;
      } else if (type == "role") {
        this.selected.Role = value.role_name;
        this.userDetails.role_id = value.role_id;
        value.role_name === "Distributor"
          ? (this.flag.isDistributor = true)
          : (this.flag.isDistributor = false);
      } else if (type == "designation") {
        this.selected.Designation = value.designation;
        this.userDetails.designation_id = value.designation_id;
      } else if (type == "cinema") {
        this.selected.Cinemas = value.cine_name;
        this.userDetails.cinema_id = value.cine_id;
      } else if (type == "department") {
        this.selected.Departments = value.dept_name;
        this.userDetails.department_id = value.dept_id;
      } else if (type == "distributor") {
        this.userDetails.d_id = value.d_id;
        this.selected.Distributor = value.d_company_name;
      }
    },
    getDistributorsList: function () {
      let payload = {
        tableName: "ms_distributors",
        d_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Distributors = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCinemasList: function () {
      this.Cinemas = [];
      let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getDepartmentList: function () {
      this.Departments = [];
      let body = this.getRequestBody("GET", undefined, this.DepartmentsMethods);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Departments = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getGenderList: function () {
      this.Gender = [];
      let payload = {
        tableName: "ms_gender",
        gender_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Gender = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getGenreList: function () {
      this.Genre = [];
      let body = this.getRequestBody("GET", undefined, this.GenresMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Genres = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCountriesList: function () {
      this.Countries = [];
      this.options = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            for (var i = 0; i < this.Countries.length; i++) {
              this.options.push(this.Countries[i].country_name);
            }
            // this.options = data.Records.filter(x => {
            //   return x.country_name;
            // });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    // getCountriesList: function() {
    //   this.Countries = [];
    //   let payload = {
    //     tableName: "ms_countries",
    //     country_is_active: "Y",
    //   };
    //   MasterService.GetActiveList(payload)
    //     .then(response => {
    //       const { data } = response;
    //       if (data.status && data.Records.length > 0) {
    //         this.Countries = data.Records;
    //       } else {
    //         // Show Errors
    //         console.log("show error :", data.message);
    //       }
    //     })
    //     .catch(this._CatchError);
    // },
    getStatesList: function (country_id) {
      let payload = {
        tableName: "ms_states",
        state_is_active: "Y",
        country_id: country_id,
      };
      MasterService.GetActiveList(payload)
        // this.States = [];
        // let body = this.getRequestBody("GET", undefined, {
        //   ...this.StatesMethod,
        //   params: { id: "country_id-" + country_id }
        // });
        // MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.States = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCountryHandler: function (country) {
      this.getStatesList(country.country_id);
    },
    onSelectStateHandler: function (state) {
      this.getCitiesList(state.state_id);
    },
    getCitiesList: function (state_id) {
      this.Cities = [];
      let payload = {
        tableName: "ms_cities",
        city_is_active: "Y",
        state_id: state_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cities = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getRolesList: function () {
      this.Roles = [];
      let body = this.getRequestBody("GET", undefined, this.RolesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Roles = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getDesignationList: function () {
      this.Designations = [];
      let body = this.getRequestBody(
        "GET",
        undefined,
        this.DesignationsMethods
      );
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Designations = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onFinalSubmit: function () {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let configHeaders = {
            headers: {
              "content-type": "application/json",
              Authorization: window.localStorage.getItem("AUTH_KEY"),
            },
          };
          SetupService.AddUser(
            {
              ...this.userDetails,
              flag: this.flag,
            },
            configHeaders
          )
            .then((response) => {
              const { data } = response;
              if (data.status) {
                SetupService.updateStatus()
                  .then((result) => {
                    console.log("result :", result);
                  })
                  .catch((err) => {
                    console.log("err :", err);
                  });
                window.localStorage.removeItem("AUTH_KEY");
                window.localStorage.clear();
                // this.onResetForm();
                this.$router.push({
                  path: "/login",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/cinemaInstallation/setupAddUser.vue